<template>
  <!-- Modal -->
  <div class="modal fade" ref="vuemodal" id="ArchivePaymentsModal2" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{billingData.name + ' （' + $invoiceTools.formatDateAt(billingData.billed_at) + '）' }}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="alert alert-success">{{translations('invoice.message_information')}}</div>
          <div class="table-scroll">
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th>{{translations('invoice.payment_day')}}</th>
                <th width="20%">{{translations('invoice.customer_name')}}</th>
                <th>{{translations('invoice.billing_amount')}}</th>
                <th>{{translations('invoice.deposit_amount')}}</th>
                <th>{{translations('invoice.transfer_fee')}}</th>
                <th>{{translations('deposit.difference')}}</th>
              </tr>
            </thead>
            <tbody class="nowrap">
              <tr>
                <td>
                  <input v-model="paidAt" type="date" class="form-control">
                </td>
                <td>{{client_name}}</td>
                <td class="right">{{Number(requestedCost).toLocaleString()}}</td>
                <td>
                  <input v-model="paid" type="text" min-value="0" class="form-control">
                </td>
                <td>
                  <input v-model="transferFee" type="text" min-value="0" class="form-control">
                </td>
                <td class="right">{{Number(remainingCost).toLocaleString()}}</td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
        <div class="modal-footer">
          <button ref="closeAddBillingModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{translations('common.close')}}</button>
          <button type="button" class="btn btn-primary" @click="addFromBilling">{{translations('common.update')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'ArchivePaymentsModal2',
  props: {
    billingData: {}
  },
  components: {
    VueElementLoading
  },
  data () {
    return {
      paidAt: '',
      transferFee: 0,
      paid: 0,
      requestedCost: 0,
      remainingCost: 0,
      isSearching: false,
      client_name: ''
    }
  },
  watch: {
    paid: {
      handler: function (data, oldData) {
        this.calcRemainingCost()
      }
    },
    transferFee: {
      handler: function (data, oldData) {
        this.calcRemainingCost()
      }
    }
  },
  mounted () {
    window.$(this.$refs.vuemodal).on('shown.bs.modal', this.getBilledPayments)
  },
  created () {
    this.calcRemainingCost()
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    calcRemainingCost () {
      this.remainingCost = Number(this.requestedCost) - (Number(this.paid) + Number(this.transferFee))
    },

    async getBilledPayments () {
      console.log(this.billingData)
      if (this.billingData === undefined) {
        return
      }

      try {
        this.isSearching = true
        let params = {
          billing_id: this.billingData.id
        }

        await this.$http.post(this.$api_url.billed_payment_list, params).then(billing => {
          if (billing.data && billing.data.status === true) {
            this.client_name = billing.data.client_name
            this.requestedCost = billing.data.total_amount_inctax
            this.transferFee = billing.data.transfer_fee
          } else {
            this.client = this.billingData.name
            this.requestedCost = 0
            this.transferFee = 0
          }

          this.isSearching = false
        })
      } catch (error) {
        this.isSearching = false
        console.log('ArchivePayments:API:getBilledPayments:error: ', error)
      }
    },

    addFromBilling () {
      if (this.paidAt.replace('/', '') === '') {
        this.$toastr.warning(this.translations('invoice.notice_enter_payment_date'))
        return
      }
      if (isNaN(Number(this.paid))) {
        this.$toastr.warning(this.translations('invoice.notice_enter_amount_half_width_numbers'))
        return
      }
      if (isNaN(Number(this.transferFee))) {
        this.$toastr.warning(this.transferFee('invoice.notice_enter_bank_transfer_half_width_numbers'))
        return
      }

      this.$dialog.confirm(this.translations('deposit.notice_save_payment_data'), {
        okText: this.translations('common.yes'),
        cancelText: this.translations('common.no')
      }).then(async () => {
        this.isSearching = true
        try {
          let paramUpdate = {
            billing_id: this.billingData.id,
            paid_at: this.paidAt.replace('/', ''),
            transfer_fee: this.transferFee,
            paid: this.paid
          }

          let addPayment = await this.$http.post(this.$api_url.billing_add_payment, paramUpdate)
          let $data = this.$invoiceTools.prepareResult(addPayment.data)

          if ($data.success === true) {
            this.$toastr.success(this.translations('deposit.notice_save_deposit_data_success'), this.translations('common.success'))
            this.$refs.closeAddBillingModal.click()
          } else {
            this.$toastr.error($data.data, this.translations('common.error'))
          }
          this.isSearching = false
        } catch (error) {
          console.log('ArchivePayments:addPayment:catch(error): ', error)
          this.$toastr.error(this.translations('deposit.notice_failed'), this.translations('common.error'))
          this.isSearching = false
        }
      })
    }
  }
}
</script>
